import React, { FC, useEffect } from 'react'
import SocialLogins from '../partials/SocialLogins'
import { Link, useHistory } from 'react-router-dom'
import { PageURLs } from '../common'
import Page from '../components/Page'
import LoginForm from '../components/LoginForm'
import { useSelector } from 'react-redux'
import { RootState } from '../store'

const Login: FC = () => {
  // TODO: Redirect away if a authenticated
  const history = useHistory()
  const { transferBookingIds } = useSelector((state: RootState) => state.app)

  const handleOnLogin = async () => {
    history.push(transferBookingIds.length > 0 ? PageURLs.CompleteBooking : PageURLs.Home)
  }

  return (
    <Page className="bg-light-blue">
      <div className="login-wrap min-vh-100 d-flex align-items-center flex-column justify-content-center flex-wrap">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="text-center">Log In</h1>
            </div>
          </div>

          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-lg-5 col-xxl-4 order-2 order-lg-0">
              <LoginForm onLogin={handleOnLogin} className="my-3 my-lg-6" />
            </div>
            {/*<div className="col-12 col-lg-2 col-xxl-1 order-1 mt-4 mt-lg-0">*/}
            {/*  <span className="h6 d-block text-center">OR</span>*/}
            {/*</div>*/}
            {/*<div className="col-12 col-lg-5 col-xxl-4 order-0 order-lg-2 mt-4 mt-lg-0">*/}
            {/*  <SocialLogins />*/}
            {/*</div>*/}
          </div>
        </div>
        <div className="register-link">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <p>
                  No account yet?{' '}
                  <Link to="/register" className="text-secondary">
                    Sign up
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default Login
